module.exports = __webpack_public_path__ + "img/RTX3080.40cb7454.jpg";